module.exports = __webpack_public_path__ + "media/zips/Transparent_BLK_WS_Logo-184c1f43a7803db814c7eee1fa0ba206.zip";